import { NotificationBell } from "@/components/notifications/NotificationBell";
import { useNotificationsAvailable } from "@/hooks/useNotifications";

/**
 * The thin bar above every page that holds the notification bell.
 *
 * Rendered only for a user who can receive notifications — the client's plan
 * grants «Notificaciones web» and they are on the school's team. Everyone else
 * gets nothing, not an empty bar, so no tenant without the feature sees its
 * pages move down.
 */
export function TopBar(): React.JSX.Element | null {
  const available = useNotificationsAvailable();
  if (!available) return null;
  return (
    <div
      data-testid="top-bar"
      className="flex h-11 shrink-0 items-center justify-end border-b border-ink-100 bg-white px-3 md:px-4"
    >
      <NotificationBell />
    </div>
  );
}
